export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-percent-line',
      title: 'Taxas Reduzidas',
      description: 'Aproveite as menores taxas de juros do mercado com o programa Minha Casa Minha Vida, tornando seu sonho mais acessível.',
    },
    {
      icon: 'ri-time-line',
      title: 'Aprovação Rápida',
      description: 'Processo ágil e descomplicado. Com documentação em ordem, sua aprovação sai em poucos dias.',
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Entrada Facilitada',
      description: 'Condições especiais de entrada que cabem no seu bolso. Comece a realizar seu sonho com valores acessíveis.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança Garantida',
      description: 'Processo 100% seguro e regulamentado. Seu investimento protegido do início ao fim.',
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Imóveis Novos',
      description: 'Acesso a empreendimentos novos e de qualidade em diversas regiões. Escolha o lar perfeito para sua família.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suporte Completo',
      description: 'Equipe especializada para te acompanhar em todas as etapas, desde a simulação até a entrega das chaves.',
    },
  ];

  return (
    <section id="beneficios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Por Que Escolher o Minha Casa Minha Vida?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Descubra todas as vantagens de financiar seu imóvel através do maior programa habitacional do Brasil
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 lg:p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Mais de 10.000 Famílias Já Realizaram o Sonho da Casa Própria
            </h3>
            <p className="text-lg text-teal-50 mb-8">
              Junte-se a milhares de brasileiros que conquistaram seu lar através do programa Minha Casa Minha Vida
            </p>
            <div className="grid sm:grid-cols-3 gap-8">
              <div>
                <p className="text-4xl font-bold text-white mb-2">10.000+</p>
                <p className="text-sm text-teal-100">Famílias Atendidas</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-white mb-2">98%</p>
                <p className="text-sm text-teal-100">Taxa de Aprovação</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-white mb-2">15 dias</p>
                <p className="text-sm text-teal-100">Tempo Médio de Aprovação</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
